import { RequestParameters } from '../types';
import { useQuery, UseQueryResult } from 'react-query';
import { getCategories } from './api.ts';
import { ICategory } from './types.ts';

export enum CategoryHook {
  List = 'categories',
}

export function useCategories(params: RequestParameters = {}): UseQueryResult<ICategory[]> {
  return useQuery([CategoryHook.List], () => getCategories(params));
}
